import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .mainFormOutlineGen {
    padding: 1.5rem;
  }
  @media (max-width: 577px) {
    .mainFormOutlineGen {
      padding: 1rem;
    }
  }
`;
